import React, { forwardRef } from 'react';
import { Check } from 'lucide-react';
import { cx } from '../utils';
import './Checklist.css';

// Tekshiruv ro'yxati. onToggle berilsa — bandlar bosiladigan (holat tashqarida saqlanadi),
// berilmasa — faqat o'qish uchun.
// items: [{ key?, label, checked }]
const Checklist = forwardRef(function Checklist({ items = [], onToggle, className, ...rest }, ref) {
  return (
    <ul {...rest} ref={ref} className={cx('ui-checklist', className)}>
      {items.map((item, index) => {
        const key = item.key ?? `${item.label}-${index}`;
        const content = (
          <>
            <span className={cx('ui-checklist__box', item.checked && 'ui-checklist__box--checked')} aria-hidden="true">
              {item.checked && <Check />}
            </span>
            <span className="ui-checklist__label">{item.label}</span>
          </>
        );
        return (
          <li key={key} className="ui-checklist__item">
            {onToggle ? (
              <button
                type="button"
                role="checkbox"
                aria-checked={Boolean(item.checked)}
                className="ui-checklist__button"
                onClick={() => onToggle(index)}
              >
                {content}
              </button>
            ) : (
              <span className="ui-checklist__static" aria-label={`${item.label}: ${item.checked ? 'bajarilgan' : 'bajarilmagan'}`}>
                {content}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
});

export default Checklist;
